module.exports = __webpack_public_path__ + "static/media/still (1).066bd33e.jpg";